import { Component } from "@angular/core";

@Component({
  selector: "admin-panel-empty",
  templateUrl: "./empty.component.html",
  styleUrls: ["./empty.component.css"]
})
export class AdminPanelEmptyComponent {

}
